const zhCN = {
  'header.brand': 'FlashSync',
  'header.tagline': '加密浏览器同步方案',
  'header.home': '首页',
  'header.dashboard': '控制台',
  'header.settings': '设置',
  'header.signedInAs': '已登录为',
  'header.logout': '退出登录',
  'header.login': '登录',
  'header.getStarted': '开始使用',

  'home.eyebrow': '隐私优先的浏览器同步',
  'home.heading': '书签、密码、笔记，一站式现代化加密同步。',
  'home.subtitle': 'FlashSync 是一款精致的自托管浏览器同步工具，取代云端同步方案。端到端加密、Chrome 扩展自动捕获、完全自主掌控的网页控制台，给你前所未有的安全感。',
  'home.trustZeroKnowledge': '零知识',
  'home.trustZeroKnowledgeDesc': '上传前本地加密',
  'home.trustImport': '支持 Chrome CSV 导入',
  'home.trustImportDesc': '轻松迁移现有密码',
  'home.trustSelfHosted': '支持自托管',
  'home.trustSelfHostedDesc': '服务器与数据尽在掌握',
  'home.feature1Heading': '所有敏感数据在客户端完成加密',
  'home.feature1Body': '密码、书签和笔记在离开浏览器之前就已加密，服务器端只能看到密文和同步元数据，绝无明文泄露的可能。',
  'home.feature2Heading': '扩展优先，开箱即用的上手体验',
  'home.feature2Body': '下载打包好的扩展包，在 Chrome 中加载，登录一次即可开始同步。与控制台共享同一账户，无缝切换。',
  'home.feature3Heading': '几分钟内导入 Chrome 密码',
  'home.feature3Body': '预览导入内容，合并到你的保险库中，明文数据仅在浏览器临时内存中存在片刻，随即完成本地加密。',
  'home.feature1Badge': '安全优先',
  'home.feature2Badge': '快速部署',
  'home.feature3Badge': '灵活导入',
  'home.sharperHeading': '更好的体验，无需牺牲隐私。',
  'home.whyHeading': '为什么团队和个人选择 FlashSync',
  'home.whyBody': '全新设计的产品在清晰度、响应速度和视觉质感之间取得了平衡，同时完整保留了现有加密工作流程，不妥协、不打折。',
  'home.installIntroHeading': '下载 Chrome 扩展，快速上手。',
  'home.installHeading': '安装扩展',
  'home.installBody': '从本站下载最新的打包 ZIP 文件，解压到本地，以"未打包扩展"方式加载。安装完成后，FlashSync 即可自动捕获密码、同步书签并管理笔记。',
  'home.installStep1': '下载并解压扩展安装包。',
  'home.installStep2': '打开 chrome://extensions。',
  'home.installStep3': '开启开发者模式。',
  'home.installStep4': '点击「加载已解压的扩展程序」，选择解压后的文件夹。',
  'home.installInChrome': '在 Chrome 中安装',
  'home.ctaHeading': '准备好开始了吗？',
  'home.ctaBody': '创建一个账户，安装扩展，一切都在简洁优雅的控制台中轻松管理。',
  'home.bottomHeading': '把日常的浏览器同步，升级为一个精致安全的加密保险库。',
  'home.launchVault': '打开保险库',
  'home.downloadZip': '下载扩展 ZIP',
  'home.viewSource': '查看源码',
  'home.downloadBtn': '下载 flashsync-chrome-extension.zip',
  'home.createAccount': '创建账户',
  'home.startWith': '开始使用 FlashSync',
  'home.existingAccount': '我已有账户',
  'home.cardVault': '保险库同步',
  'home.cardVaultSub': '书签、密码、笔记',
  'home.cardVaultDesc': '扩展和控制台统一的加密工作流。',
  'home.cardBookmarks': '书签已同步',
  'home.cardPasswords': '密码已导入',
  'home.cardControl': '由你掌控',

  'login.eyebrow': '欢迎回来',
  'login.heading': '解锁你的 FlashSync 加密工作空间。',
  'login.body': '登录后即可在全新设计的控制台中访问书签、笔记和密码保险库。',
  'login.benefit1Heading': '零知识访问',
  'login.benefit1Body': '登录后，你的数据在客户端本地解密，服务器端无从得知。',
  'login.benefit2Heading': '统一保险库',
  'login.benefit2Body': '一个地方，集中管理书签、密码和笔记。',
  'login.formHeading': '登录 FlashSync',
  'login.formBody': '使用你的账户凭据连接到你的服务器。',
  'login.email': '邮箱',
  'login.password': '密码',
  'login.serverURL': '服务器地址',
  'login.advancedShow': '显示高级设置',
  'login.advancedHide': '隐藏高级设置',
  'login.serverHelp': '指定 FlashSync 要连接的服务器地址，支持自托管。',
  'login.btn': '登录',
  'login.loading': '登录中...',
  'login.noAccount': '还没有账户？创建一个',
  'login.enterAll': '请输入邮箱和密码',
  'login.enterServer': '请输入服务器地址',

  'register.eyebrow': '创建你的保险库',
  'register.heading': '开启一趟既美观又安心的私人同步之旅。',
  'register.body': '注册一次，连接你的服务器，使用同一账户即可在扩展和控制台中登录。',
  'register.benefit1Heading': '导入现有数据',
  'register.benefit1Body': '一键导入 Chrome 密码，书签和笔记自动保持同步。',
  'register.benefit2Heading': '完全自托管',
  'register.benefit2Body': '部署你自己的后端，对基础设施拥有完全控制权。',
  'register.formHeading': '创建 FlashSync 账户',
  'register.formBody': '设置你的账户凭据，并将客户端连接到你要使用的 FlashSync 服务器。',
  'register.email': '邮箱',
  'register.password': '密码',
  'register.confirmPassword': '确认密码',
  'register.serverURL': '服务器地址',
  'register.advancedShow': '显示高级设置',
  'register.advancedHide': '隐藏高级设置',
  'register.serverHelp': '指定 FlashSync 要连接的服务器地址，支持自托管。',
  'register.btn': '创建账户',
  'register.loading': '注册中...',
  'register.hasAccount': '已经有账户了？去登录',
  'register.fillAll': '请填写所有字段',
  'register.passwordsMatch': '两次输入的密码不一致',
  'register.enterServer': '请输入服务器地址',
  'register.success': '注册成功！请登录。',

  'dashboard.passwords': '密码',
  'dashboard.bookmarks': '书签',
  'dashboard.notes': '笔记',
  'dashboard.total': '总计',
  'dashboard.totalItems': '总条目数',
  'dashboard.lastSync': '上次同步：',
  'dashboard.never': '从未同步',
  'dashboard.loading': '数据加载中...',
  'dashboard.decryptingPasswords': '正在解密密码...',
  'dashboard.decryptingBookmarks': '正在解密书签...',
  'dashboard.decryptingNotes': '正在解密笔记...',
  'dashboard.decrypting': '解密中...',
  'dashboard.passwordVault': '密码保险库',
  'dashboard.yourBookmarks': '我的书签',
  'dashboard.secretNotes': '私密笔记',
  'dashboard.importCSV': '导入 Chrome CSV',
  'dashboard.addPassword': '添加密码',
  'dashboard.addNote': '添加笔记',
  'dashboard.unlockVault': '解锁保险库',
  'dashboard.decrypt': '解密',
  'dashboard.cancel': '取消',
  'dashboard.import': '导入',
  'dashboard.importing': '导入中...',
  'dashboard.save': '保存',
  'dashboard.saving': '保存中...',
  'dashboard.delete': '删除',
  'dashboard.hide': '隐藏',
  'dashboard.show': '显示',
  'dashboard.untitledPassword': '未命名密码',
  'dashboard.noUsername': '（无用户名）',
  'dashboard.searchPlaceholder': '按网站或用户名搜索',
  'dashboard.noPasswordsMatch': '没有匹配的密码。',
  'dashboard.noPasswordsYet': '还没有同步任何密码。',
  'dashboard.noPasswordsHint': '你可以在这里手动添加、导入 Chrome 密码 CSV 文件，或通过扩展自动同步。',
  'dashboard.noBookmarks': '没找到书签。',
  'dashboard.noBookmarksHint': '使用 Chrome 扩展即可自动同步你的书签。',
  'dashboard.noNotes': '还没有同步任何笔记。',
  'dashboard.noNotesHint': '在这里创建笔记，或通过 Chrome 扩展同步回来。',
  'dashboard.importPreview': '准备导入 {count} 条记录：{additions} 条新增，{updates} 条更新。',
  'dashboard.importSkipped': '已跳过 CSV 中 {count} 条无效记录。',
  'dashboard.unlockPasswords': '输入你的主密码，在浏览器中解密、编辑和导入已同步的密码。',
  'dashboard.unlockBookmarks': '输入你的主密码，在浏览器中解密已同步的书签数据。',
  'dashboard.unlockNotes': '输入你的主密码，解密并编辑已同步的私密笔记。',
  'dashboard.enterMasterPassword': '输入主密码',
  'dashboard.unlockPrompt': '请输入你的主密码以解锁加密的密码、书签和笔记。',
  'dashboard.masterPassword': '主密码',
  'dashboard.newNote': '新建笔记',
  'dashboard.editNote': '编辑笔记',
  'dashboard.noteTitle': '标题',
  'dashboard.noteTitlePlaceholder': '可选，留空亦可',
  'dashboard.noteContent': '私密内容',
  'dashboard.noteContentPlaceholder': '在这里写下你的笔记...',
  'dashboard.untitledNote': '未命名笔记',
  'dashboard.emptyNote': '空白笔记',
  'dashboard.newPassword': '新建密码',
  'dashboard.editPassword': '编辑密码',
  'dashboard.passwordTitle': '标题',
  'dashboard.passwordTitlePlaceholder': '可选，留空亦可',
  'dashboard.passwordURL': '网站地址',
  'dashboard.passwordURLPlaceholder': 'https://example.com/login',
  'dashboard.passwordUsername': '用户名',
  'dashboard.passwordUsernamePlaceholder': 'alice@example.com',
  'dashboard.passwordField': '密码',
  'dashboard.passwordPlaceholder': '必填',
  'dashboard.hidePassword': '隐藏密码',
  'dashboard.showPassword': '显示密码',
  'dashboard.decryptBookmarksFailed': '书签解密失败，请重试。',
  'dashboard.decryptNotesFailed': '笔记解密失败，请重试。',
  'dashboard.decryptPasswordsFailed': '密码解密失败，请重试。',
  'dashboard.loadSyncFailed': '同步数据加载失败，请稍后重试。',
  'dashboard.saltFailed': '无法从服务器获取加密盐值。',
  'dashboard.invalidPassword': '主密码错误，或解密数据失败。',
  'dashboard.notesConflict': '笔记已在其他设备上被修改。已为你加载最新加密版本，请检查后再试。',
  'dashboard.saveNotesFailed': '笔记保存失败，请重试。',
  'dashboard.enterNoteContent': '保存前请先输入标题或笔记内容。',
  'dashboard.passwordsConflict': '密码已在其他设备上被修改。已为你加载最新加密保险库，请检查后再试。',
  'dashboard.savePasswordsFailed': '密码保存失败，请重试。',
  'dashboard.enterURLPassword': '保存前请先输入网站地址和密码。',
  'dashboard.parseFailed': '密码导入文件解析失败。',
  'dashboard.serverSaltMissing': '服务器未返回加密盐值',

  'settings.general': '通用设置',
  'settings.changePassword': '修改密码',
  'settings.account': '账户',
  'settings.generalDesc': '管理客户端连接的服务器地址和同步频率。',
  'settings.changePasswordDesc': '无需离开控制台即可更改你的账户密码。',
  'settings.signedInAs': '已登录为',
  'settings.serverURL': '服务器地址',
  'settings.serverURLHelp': '你的 FlashSync 服务器地址。',
  'settings.save': '保存设置',
  'settings.saving': '保存中...',
  'settings.currentPassword': '当前密码',
  'settings.newPassword': '新密码',
  'settings.confirmNewPassword': '确认新密码',
  'settings.changePasswordBtn': '修改密码',
  'settings.changing': '修改中...',
  'settings.logout': '退出登录',
  'settings.savedSuccess': '设置已保存',
  'settings.passwordChanged': '密码已修改',
  'settings.loadFailed': '设置加载失败，请重试。',
  'settings.saveFailed': '设置保存失败，请重试。',
  'settings.passwordMismatch': '两次输入的新密码不一致',
  'settings.changeFailed': '密码修改失败，请重试。',

  'notfound.eyebrow': '页面未找到',
  'notfound.heading': '你要访问的页面不在这个保险库里。',
  'notfound.body': '页面可能已被移动、链接或许已失效，或者该路径在当前 FlashSync 版本中并不存在。',
  'notfound.returnHome': '返回首页',
  'notfound.openDashboard': '打开控制台',

  'footer.tagline': '零知识同步',
  'footer.brand': 'FlashSync',
  'footer.desc': '一款精致的自托管加密同步方案，跨设备管理书签、密码和笔记。',
  'footer.product': '产品',
  'footer.access': '访问',
  'footer.resources': '资源',
  'footer.overview': '概览',
  'footer.dashboard': '控制台',
  'footer.settings': '设置',
  'footer.login': '登录',
  'footer.createAccount': '创建账户',
  'footer.downloadExt': '下载扩展',
  'footer.sourceCode': '源码',
  'footer.deployDocs': '部署文档',
  'footer.projectUpdates': '项目更新',
  'footer.copyright': '为隐私浏览器同步而生，端到端加密。',

  'lang.en': 'EN',
  'lang.zhCN': '中',
};

export default zhCN;
